import { maybe } from "@saleor/misc";
import { SmopUserTypeCode } from "@saleor/types/globalTypes";
import {
  createReport,
  downloadReport,
  excelWorksheetBuilder
} from "@saleor/utils/downloadReport";

import { formatDate } from "../utils/misc";

export const checkUserType = (userType: SmopUserTypeCode) => {
  switch (userType) {
    case SmopUserTypeCode.SELLER_MASTER:
      return 2;
    case SmopUserTypeCode.STORE_ADMIN:
      return 1;
    default:
      return 4;
  }
};

export const filterReportData = (reportData, reportFields) => {
  const filteredData = reportData?.map(data => {
    delete data.__typename;

    data.mall_name = data.mall_name.toUpperCase();
    data.payment_method = data.payment_method.toUpperCase();
    data.brand_name = data.brand_name.toUpperCase();

    // Filters object to remove extra column
    const erase = Object.keys(data).filter(
      e => !Object.keys(reportFields).includes(e)
    );

    // Deletes here
    for (const i in erase) {
      if ({}?.hasOwnProperty.call(erase, i)) {
        delete data[`${erase[i]}`];
      }
    }
    return data;
  });

  return filteredData;
};

export const layoutSummary = summaryData => {
  const {
    brand_name,
    coverage_start_date,
    coverage_end_date,
    creditable_withholding_tax_on_prepaid,
    legal_name,
    mall_name,
    net_sales,
    payout_id,
    settlement_date,
    tenant_discount,
    tenant_voucher,
    total_deductions,
    total_gross_amount,
    adjustment_on_payment_fee,
    adjustment_on_delivery_fee,
    withholding_tax_on_payment_fee,
    penalties,
    other_adjustments,
    total_adjustments,
    net_amount_for_settlement,
    in_store_cash_payments,
    total_payment_fee,
    total_tax,
    gross_amount_settlement
  } = summaryData;

  return [
    ["Payout ID", payout_id],
    ["PAYOUT SUMMARY", " "],
    ["Mall Name", mall_name],
    ["Company Name", legal_name],
    ["Brand Name", brand_name],
    [
      "Period Covered",
      `${formatDate(coverage_start_date)} - ${formatDate(coverage_end_date)}`
    ],
    ["Settlement Date", formatDate(settlement_date)],
    [" ", " "],
    ["TRANSACTIONS", "AMOUNT"],
    ["Gross", total_gross_amount?.toFixed(2)],
    [
      "Discount",
      maybe(() => tenant_discount, null) ? tenant_discount.toFixed(2) : " "
    ],
    ["Net", maybe(() => net_sales, null) ? net_sales.toFixed(2) : " "],
    [" ", " "],
    ["DEDUCTIONS", " "],
    ["Vouchers", tenant_voucher?.toFixed(2)],
    ["Payment Fee", total_payment_fee?.toFixed(2)],
    ["Subtotal", total_deductions?.toFixed(2)],
    [" ", " "],
    ["ADJUSTMENTS", " "],
    [
      "Payment Fee",
      maybe(() => adjustment_on_payment_fee, null)
        ? adjustment_on_payment_fee.toFixed(2)
        : " "
    ],
    [
      "Delivery Fee",
      maybe(() => adjustment_on_delivery_fee, null)
        ? adjustment_on_delivery_fee.toFixed(2)
        : " "
    ],
    ["Penalties", maybe(() => penalties, null) ? penalties.toFixed(2) : " "],
    [
      "Other Adjustments",
      maybe(() => other_adjustments, null) ? other_adjustments.toFixed(2) : " "
    ],
    ["Subtotal", total_adjustments?.toFixed(2)],
    [" ", " "],
    ["TAX", " "],
    [
      "Creditable Withholding Tax on Card Transaction",
      creditable_withholding_tax_on_prepaid?.toFixed(2)
    ],
    [
      "Withholding Tax on Payment Fee",
      withholding_tax_on_payment_fee?.toFixed(2)
    ],
    ["Subtotal", maybe(() => total_tax, null) ? total_tax.toFixed(2) : " "],
    [" ", " "],
    [
      "Gross Amount for Settlement",
      maybe(() => gross_amount_settlement, null)
        ? gross_amount_settlement.toFixed(2)
        : " "
    ],
    ["In-store Cash Payment", in_store_cash_payments?.toFixed(2)],
    ["NET AMOUNT FOR SETTLEMENT", net_amount_for_settlement?.toFixed(2)]
  ];
};

export const downloadMerchantSettlementReport = (
  data,
  fields,
  filename,
  summaryData
) => {
  createReport().then(workbook => {
    const summaryWorksheet = excelWorksheetBuilder(workbook, "Summary");
    summaryWorksheet.addSummaryRecords(summaryData);

    const orderDetailsWorksheet = excelWorksheetBuilder(
      workbook,
      "Order Details"
    );
    orderDetailsWorksheet.addHeaders(fields);
    orderDetailsWorksheet.addRecords(data);

    downloadReport(workbook, filename);
  });
};
